import React from "react";

import { withRouter } from "react-router";

import { inject } from "mobx-react";

import styled, { withTheme } from "styled-components";

// import { FormattedMessage, injectIntl } from 'react-intl';

import locales from "../utils/locales";

import timestamp from "../utils/timestamp";

const Wrapper = styled.div`
  width: 100%;
  max-width: 250px;
  height: 100%;

  position: absolute;

  top: 0;
  left: 0;

  &:after {
    content: "";
    width: 100%;
    background-repeat: no-repeat;
    background-size: contain;

    position: absolute;
    left: 0;
    right: 0;

    z-index: 3;
    height: 50vh;
    background-image: url(./assets/images/sarah-buiu.png?${timestamp});
    background-position: left bottom;
    bottom: 25px;
  }

  @media (orientation: portrait) {
    display: none;
  }
`;

const Logo = styled.img.attrs({
  title: "Tito and the Birds Logo",
  alt: "Tito and the Birds Logo"
})`
  display: block;
  max-width: 200px;
  height: auto;
`;

const Title = styled.h3`
  font-family: "Patrick Hand", cursive;

  background-image: url(./assets/images/title.png?${timestamp});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  max-width: 100%;

  font-size: 1.5em;
  font-weight: regular;
  text-transform: uppercase;
  text-align: center;
  text-shadow: 1px 1px 0px black;
  padding: 0.5em 1em;

  color: #abcadf;
`;

const mapper = (stores, props) => ({
  intl: locales[props.match.params.locale || stores.uiStore.getLocale.get()]
});

export default withRouter(
  withTheme(
    inject(mapper)(({ intl }) => (
      <Wrapper>
        <Logo src={intl.LOGO} />
        <Title dangerouslySetInnerHTML={{ __html: intl.SUBTITLE }} />
      </Wrapper>
    ))
  )
);



// WEBPACK FOOTER //
// ./src/components/Aside.js